import { cn } from '@/lib/utils'
import type { CandidateStatus, PaymentStatus } from '@/types'

const STATUS_CONFIG: Record<string, { label: string; className: string }> = {
  // Freelance statuses
  nouveau: { label: 'Nouveau', className: 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300' },
  contacte: { label: 'Contacté', className: 'bg-blue-100 text-blue-700' },
  en_discussion: { label: 'En discussion', className: 'bg-yellow-100 text-yellow-700' },
  propose: { label: 'Proposé', className: 'bg-orange-100 text-orange-700' },
  en_mission: { label: 'En mission', className: 'bg-green-100 text-green-700' },
  non_retenu: { label: 'Non retenu', className: 'bg-red-100 text-red-600' },
  en_attente: { label: 'En attente', className: 'bg-purple-100 text-purple-700' },
  // CDI statuses
  soumis_client: { label: 'Soumis client', className: 'bg-orange-100 text-orange-700' },
  place_pe_cours: { label: 'Placé – PE en cours', className: 'bg-teal-100 text-teal-700' },
  pe_validee: { label: 'PE validée', className: 'bg-green-100 text-green-700' },
  // Mandate statuses
  en_cours: { label: 'En cours', className: 'bg-blue-100 text-blue-700' },
  pourvu: { label: 'Pourvu', className: 'bg-green-100 text-green-700' },
  annule: { label: 'Annulé', className: 'bg-red-100 text-red-600' },
  // Payment statuses
  recu: { label: 'Reçu', className: 'bg-green-100 text-green-700' },
  en_retard: { label: 'En retard', className: 'bg-red-100 text-red-600' },
  // Collab statuses
  pending: { label: 'En attente', className: 'bg-yellow-100 text-yellow-700' },
  accepted: { label: 'Active', className: 'bg-green-100 text-green-700' },
  declined: { label: 'Refusée', className: 'bg-red-100 text-red-600' },
  ended: { label: 'Terminée', className: 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300' },
}

interface BadgeProps {
  status: CandidateStatus | PaymentStatus | string
  className?: string
}

export function StatusBadge({ status, className }: BadgeProps) {
  const config = STATUS_CONFIG[status] ?? { label: status, className: 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300' }
  return (
    <span className={cn('inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium', config.className, className)}>
      {config.label}
    </span>
  )
}

interface PaymentBadgeProps {
  status: PaymentStatus
}

export function PaymentBadge({ status }: PaymentBadgeProps) {
  const icons: Record<PaymentStatus, string> = {
    en_attente: '⏳',
    recu: '✅',
    en_retard: '🔴',
  }
  const config = STATUS_CONFIG[status]
  return (
    <span className={cn('inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium', config?.className ?? '')}>
      {icons[status]} {config?.label ?? status}
    </span>
  )
}
